var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7163 15.096L37.4313 8.38107M41.2684 4.54395L37.4313 8.38107L41.2684 4.54395ZM22.831 22.9813C23.8216 23.9588 24.6091 25.1225 25.1481 26.4056C25.6872 27.6886 25.9671 29.0656 25.9717 30.4573C25.9764 31.849 25.7057 33.2278 25.1753 34.5144C24.6449 35.801 23.8652 36.97 22.8811 37.9541C21.8971 38.9382 20.7281 39.7178 19.4415 40.2483C18.1548 40.7787 16.776 41.0493 15.3843 41.0447C13.9927 41.04 12.6157 40.7601 11.3326 40.2211C10.0496 39.6821 8.88583 38.8946 7.90839 37.9039C5.98624 35.9138 4.92265 33.2483 4.94669 30.4816C4.97073 27.7149 6.08048 25.0683 8.03693 23.1118C9.99338 21.1554 12.64 20.0456 15.4067 20.0216C18.1734 19.9975 20.8389 21.0611 22.8291 22.9833L22.831 22.9813ZM22.831 22.9813L30.7163 15.096L22.831 22.9813ZM30.7163 15.096L36.472 20.8517L43.187 14.1368L37.4313 8.38107L30.7163 15.096Z",
    stroke: "inherit",
    strokeWidth: 3.83713,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.ac77deaf255cae97e0abfb14c440ead9.svg";
export { ForwardRef as ReactComponent };